export const getAppState = (state: any): any => state?.appState;
export const getAppRouteHistory = (state: any): any =>
  state?.appState?.routeHistory;
